import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/SimpleAuthContext';
import { isPrivilegedUser } from '../../utils/accessControl';

const ProtectedRoute = ({ children, requirePrivileged = false }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--background-gray)'
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '4px solid var(--primary-yellow-light)',
          borderTop: '4px solid var(--primary-yellow)',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check for privileged access if required
  if (requirePrivileged) {
    if (!isPrivilegedUser(user)) {
      // Redirect to help home with access denied message
      return <Navigate to="/help" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
